import PreAuthorizationProcedure from './PreAuthorizationProcedure';

export default PreAuthorizationProcedure;